"use client";
import { ReactNode } from "react";

export default function ScrollLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative w-full bg-[#FAFCFF] text-slate-900 overflow-hidden selection:bg-[#2040CF] selection:text-white min-h-screen font-sans">
      {/* Actual Content Wrapper.
          NO z-index here: `relative z-10` used to create a stacking context
          that capped every fixed overlay inside the sections (e.g. the hero's
          video modal, z-[70]) at layer 10 — below the z-50 header and the
          floating WhatsApp button. There are no background siblings to stack
          above, so the z-index only caused that bug. */}
      <div className="relative w-full flex flex-col items-center">
        {children}
      </div>
    </div>
  );
}

export function AnimatedSection({ 
  children, 
  className = "",
}: { 
  children: ReactNode, 
  delay?: number, 
  className?: string,
  animationType?: string
}) {
  return (
    <section className={`w-full ${className}`}>
      {children}
    </section>
  );
}

